import React, { Component } from "react";

export default class Index extends Component {
	render() {
		return <div>App is running {process.env.NODE_ENV} </div>;
	}
}
